"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));
var LinearProgress = function (_a) {
    var classes = _a.classes, _b = _a.color, color = _b === void 0 ? 'primary' : _b, value = _a.value, valueBuffer = _a.valueBuffer, _c = _a.variant, variant = _c === void 0 ? 'indeterminate' : _c;
    return (react_1.default.createElement(LinearProgress_1.default, { classes: classes, color: color, value: value, valueBuffer: valueBuffer, variant: variant }));
};
exports.default = LinearProgress;
